exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-search-component .taginput.control .taginput-container{padding-right:0!important}.news-search-component .taginput.control .taginput-container .tag{overflow:hidden;text-overflow:ellipsis;max-width:calc(100% - .375rem);display:inline-block;position:relative;padding-top:.3rem;padding-right:1.75rem}.news-search-component .taginput.control .taginput-container .tag .delete{position:absolute;right:.75rem;top:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09d29960","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/views/news/Search.vue
// module id = b/0W
// module chunks = 1